import React from 'react';
import { Divider, Radio } from '@mui/material';
import { useWeaveThemeContext } from './WeaveContext';

import { INFO360_THEMES } from './theme.types';
import { Button } from '../../../components';
import { useThemeVariables } from '../../../utils/features';
import { useGlobalization } from '../../../contexts';
import { StyledFormControlLabel, StyledRadioGroup } from './ThemePicker.styles';
import { Typography } from '@mui/material';

export default function ThemePicker() {
	const { t } = useGlobalization();
	const { setTheme, theme, isWeaveTheme = false } = useWeaveThemeContext();
	const { darkButtonEnabled, displayThemePicker } = useThemeVariables();

	if (!displayThemePicker) return <></>;

	return (
		<>
			<Divider />
			<div style={{ padding: '0 1rem' }}>
				<Typography variant="subtitle1">{t('Theme')}</Typography>
				<StyledRadioGroup
					$weaveTheme={isWeaveTheme}
					row
					style={{
						justifyContent: 'space-between',
						flexWrap: 'nowrap',
					}}
					aria-labelledby="theme-radio-buttons-group-label"
					defaultValue={INFO360_THEMES.Light}
					name="theme-radio-buttons-group"
					value={theme}
					color="secondary"
					aria-label={t('theme selection')}>
					<Button
						onClick={() => {
							setTheme(INFO360_THEMES.Light);
						}}>
						<StyledFormControlLabel
							$weaveTheme={isWeaveTheme}
							style={{ textTransform: 'none' }}
							value={INFO360_THEMES.Light}
							control={
								<Radio
									checked={theme === INFO360_THEMES.Light}
								/>
							}
							label={t('Default')}
						/>
					</Button>
					{darkButtonEnabled && (
						<Button
							onClick={() => {
								setTheme(INFO360_THEMES.Dark);
							}}>
							<StyledFormControlLabel
								$weaveTheme={isWeaveTheme}
								style={{ textTransform: 'none' }}
								value={INFO360_THEMES.Dark}
								control={
									<Radio
										checked={theme === INFO360_THEMES.Dark}
									/>
								}
								label={t('Dark')}
							/>
						</Button>
					)}
					<Button
						onClick={() => {
							setTheme(INFO360_THEMES.Classic);
						}}>
						<StyledFormControlLabel
							$weaveTheme={isWeaveTheme}
							style={{ textTransform: 'none' }}
							value={INFO360_THEMES.Classic}
							control={
								<Radio
									checked={theme === INFO360_THEMES.Classic}
								/>
							}
							label={t('Classic')}
						/>
					</Button>
				</StyledRadioGroup>
			</div>
		</>
	);
}
